import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { AiOutlineCloseCircle } from "react-icons/ai";
import moment from "moment";
import toastr from "toastr";
import { getTrainingManagementStatusClass, TM_STATUS } from "../../CONSTANTS";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import Decline from "app/_pages/_healthSafetyEnvironment/IncidentManagement/DeclinePopup";
import FormBtn from "app/Components/CommanComponents/FormBtn";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import {
  DDMMYYYYFormat,
  isBetween,
  isSameOrAfter,
  YYYYMMDDFormat,
} from "app/_helpers/dateHelper";
import { getQueryStringAsObject } from "app/_helpers/helper";
import {
  absentTraineeStatus,
  addTrainingToBatch,
  getAllTrainingBatches,
  removeTraineeStatue,
  updateAssignersStatus,
} from "app/_services/ehs/ehsTrainingServices";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { FaCheck, FaUserMinus } from "react-icons/fa";
import {
  trainingbatchFilterFields,
  TRAINING_STATUS,
  validateBatchRowFilter,
} from "../../CONSTANTS";
import { confirmAlert } from "react-confirm-alert";
import {
  isUserMM,
  isUserSO,
  isUserVTO,
} from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
// import FormBtn from "app/Components/CommanComponents/FormBtn";
// import FormSelect from "app/Components/_form/FormSelect/FormSelect";
// import { AiOutlineCloseCircle } from "react-icons/ai";
import { isBefore } from "date-fns";
// import moment from "moment";
// import { isSameOrAfter, YYYYMMDDFormat } from "app/_helpers/dateHelper";
import TrainingBatchView from "./TrainingBatchView";
import TrainingBatchFilters from "./TrainingBatchFilters";
import { useForm } from "app/_helpers/hooks";
import { validateRowFilter } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/CONSTANTS";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

function TrainingBatchTab({
  trainings,
  trainingInitialData,
  editRow = false,
  tab,
  showFilter,
  setShowFilterBtn = () => {},
}) {
  const [batches, setBatches] = useState([]);
  const [initialBatches, setInitialBatches] = useState([]);
  const [tableList, setTableList] = useState([]);
  const [finalTableList, setFinalTableList] = useState([]);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [form, setForm] = useState({});
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const [filterForm, onChangeFilter, setFilterForm] = useForm(
    {},
    trainingbatchFilterFields
  );
  //const [showFilter, setShowFilter] = useState(false);

  const onReset = () => setFilterForm({ batchName: "", centerName: "", centerCode: "" });

  const history = useHistory();

  const onChangeBatch = ({ target: { name, value, type, checked } }) => {
    setForm((prevForm) => {
      const updates = {
        ...prevForm,
        [name]: type === "checkbox" ? checked : value,
      };

      return { ...updates };
    });
  };

  const dueTraining = useMemo(() => {
    if (!selectedBatch) return [];

    return trainings
      ?.filter(
        (d) =>
          d.trainingStatus === TRAINING_STATUS.due &&
          d.trainingType === selectedBatch?.traineeList?.find((d) => d.id)?.trainingType
      )
      ?.map((d) => ({ label: d.traineeID, id: d.id }));
  }, [selectedBatch, trainings]);

  //
  const initialData = useCallback(async () => {
    if (trainingInitialData) trainingInitialData();

    // getAllTrainingBatches().then((response) => {
    //   if (!response?.data) return;

    //   const batchData = editRow
    //     ? response?.data
    //         ?.filter(
    //           (row) =>
    //             row.traineeList.filter(
    //               (d) => d.trainingStatus === TRAINING_STATUS.scheduled
    //             ).length > 0
    //         )
    //         .map((d) => ({
    //           ...d,
    //           traineeList: d.traineeList.filter(
    //             (d) => d.trainingStatus === TRAINING_STATUS.scheduled
    //           ),
    //         }))
    //     : response?.data;

    //   setBatches(batchData);
    //   setInitialBatches(response?.data);
    //   setTableList(batchData);
    //   setFinalTableList(batchData);
    // });

    try {
      const response = await getAllTrainingBatches();

      if (!response?.data) {
        // Handle the case where data is not received
        setLoading(false);
        return;
      }
      const batchData = editRow
        ? response?.data
            ?.filter(
              (row) =>
                row.traineeList.filter(
                  (d) => d.trainingStatus === TRAINING_STATUS.scheduled
                ).length > 0
            )
            .map((d) => ({
              ...d,
              traineeList: d.traineeList.filter(
                (d) => d.trainingStatus === TRAINING_STATUS.scheduled
              ),
            }))
        : response?.data;

      setBatches(batchData);
      setInitialBatches(response?.data);
      setTableList(batchData);
      setFinalTableList(batchData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error as needed, e.g., show an error message
      setLoading(false);
    }
  }, [editRow, trainingInitialData]);

  const onClickRow = useCallback(
    (row) => {
      setShowFilterBtn(false);
      setSelectedBatchId(row?.id);
      setSearch("");
      setSelectedBatch(row);
    },
    [setShowFilterBtn]
  );

  const sortableColumn = useMemo(
    () => [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "siteName",
        text: "Location",
        sort: true,
      },
      {
        dataField: "from",
        text: "From",
        sort: true,
      },
      {
        dataField: "to",
        text: "To",
        sort: true,
      },
      {
        dataField: "session",
        text: "Session",
        sort: true,
      },
      {
        dataField: "trainingCategoryName",
        text: "Skill Category",
        sort: true,
      },
      {
        dataField: "trainingTypeView",
        text: "Course Type",
        sort: true,
      },
      {
        dataField: "schedule",
        text: "Schedule",
        sort: true,
      },
      {
        dataField: "batchId",
        text: "Batch No",
        sort: true,
        formatter: (cell, row, rowIndex) => {
          return (
            <span className="icons pointer text-cyanBlue" onClick={() => onClickRow(row)}>
              {row.batchId}
            </span>
          );
        },
      },
      {
        dataField: "centerCode",
        text: "Centre Code",
        sort: true,
      },
      // {
      //   dataField: "centerName",
      //   text: "Centre",
      //   sort: true,
      // },

      // {
      //   dataField: "trainingDateView",
      //   text: "Training Start Date",
      //   sort: true,
      //   // formatter: (startDate) => {
      //   //   return DDMMYYYYFormat(startDate);
      //   // },
      // },
      // {
      //   dataField: "areaName",
      //   text: "Area",
      //   sort: true,
      // },
      // {
      //   dataField: "duration",
      //   text: "Duration",
      //   sort: true,
      // },
      {
        dataField: "count",
        text: "Count",
        sort: true,
      },
      {
        dataField: "batchStatusView",
        text: "Status",
        sort: true,
        formatter: (status, row) => {
          return <div className={getTrainingManagementStatusClass(status)}>{status}</div>;
        },
      },
    ],
    [onClickRow]
  );

  useEffect(() => {
    initialData();
  }, [initialData]);
  useEffect(() => {
    setTableList(
      selectedBatchId
        ? batches.find((d) => d.id === selectedBatchId)?.traineeList || []
        : batches.filter((row) => {
            console.log("abcRow", row);
            if (!search) return true;

            if (
              row.traineeList?.find((t) =>
                t.traineeName?.toLowerCase().includes(search.toLowerCase())
              )
            )
              return true;

            for (const key in row) {
              if (typeof row[key] !== "string" && typeof row[key] !== "number") continue;

              if (row[key].toString().toLowerCase().includes(search.toLowerCase()))
                return true;
            }

            return false;
          })
    );
  }, [batches, search, selectedBatchId]);

  const resetBatch = () => {
    setSelectedBatchId(null);
    setSelectedBatch(null);
    setSearch("");
    setShowFilterBtn(true);
    setTableList([]);
  };

  const CustomSearch = useCallback(() => {
    return (
      <label htmlFor="search-bar-0" className="search-label">
        <span className="sr-only">Search this table</span>
        <input
          id="search-bar-0"
          type="text"
          aria-label="enter text you want to search"
          className="form-control mb-0"
          placeholder="Search"
          onChange={(e) => setSearch(e.target.value)}
        />
      </label>
    );
  }, []);
  useEffect(() => {
    if (!tab) return;
    let data = [];
    if (tab === 1) {
      data = initialBatches
        .filter((row) => !isSameOrAfter(moment(), YYYYMMDDFormat(row?.trainingDate)))
        ?.filter((obj) => {
          return validateBatchRowFilter(obj, filterForm);
        });
    } else if (tab === 2) {
      data = initialBatches
        .filter((row) => isSameOrAfter(moment(), YYYYMMDDFormat(row?.trainingDate)))
        ?.filter((obj) => {
          return validateBatchRowFilter(obj, filterForm);
        });
    }

    setBatches(data);
  }, [filterForm, initialBatches, tab]);

  useEffect(() => {
    if (tab || editRow) return;
    let data = initialBatches?.filter((obj) => {
      return validateBatchRowFilter(obj, filterForm);
    });
    setBatches(data);
  }, [editRow, filterForm, initialBatches, tab]);

  useEffect(() => {
    if (!editRow) return;
    let data = finalTableList?.filter((obj) => {
      return validateBatchRowFilter(obj, filterForm);
    });
    setBatches(data);
  }, [editRow, filterForm, finalTableList]);

  const queryRef = useRef(false);

  useEffect(() => {
    if (queryRef.current) return;

    const q = getQueryStringAsObject();

    if (!q.selectedBatchId) {
      queryRef.current = true;
      return;
    }

    const found = tableList.find((r) => r.id === +q.selectedBatchId);

    if (!found) return;

    setSelectedBatch(found);
    setSelectedBatchId(+q.selectedBatchId);
    queryRef.current = true;
    history.replace("/health-safety-and-environment/training-management/assign?tab=6");
  }, [tableList, history]);

  const tableToolbarBeforeView = () =>
    showFilter && (
      <TrainingBatchFilters
        fields={trainingbatchFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChangeFilter}
        onReset={onReset}
      />
    );

  return (
    <div>
      {selectedBatchId ? (
        <TrainingBatchView
          trainings={trainings}
          trainingInitialData={trainingInitialData}
          batchId={selectedBatchId}
          editRow={editRow}
        />
      ) : (
        <div>
          {!loading ? (
            <SearchBootstrapTable
              data={tableList.map((d, idx) => ({ ...d, sid: idx + 1 }))}
              searchKey={"trainingBatchesDesktopSearch"}
              columns={sortableColumn}
              // CustomSearch={CustomSearch}
              tableBeforeSearch={tableToolbarBeforeView}
              tableKey="trainingBatches"
            />
          ) : (
            <NetZeroLoader />
          )}
        </div>
      )}
      {selectedBatchId && (
        <div className="mt-2 text-center">
          <Button onClick={resetBatch}>Back</Button>
        </div>
      )}
    </div>
  );
}

export default TrainingBatchTab;
